<template>
<kt-panel v-if="status === 'success'">
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse"
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row v-if="$can('read', 'ticket')">
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="id">
                                            {{ $t('label.id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="id"
                                                dir="ltr"
                                                name="id"
                                                id="id"
                                                v-model="query.id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="created_at">
                                            {{ $t('label.created_at') }}
                                        </kt-form-label>
                                        <button id="created_at"
                                                @click="clearCreatedAt"
                                                class=" btn btn-label-danger trash-btn"
                                                type="button"
                                        >
                                            <i class="la la-trash-o"></i>
                                        </button>
                                        <datePicker
                                            color="#00c1a4"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            v-model="query.created_at" type="date" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="category">
                                            {{ $t('label.category') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="category" class="form-control" name="category" v-model="query.category">
                                            <option :value="null"></option>
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(category, index) in categories"
                                                    v-bind:value="category.value"
                                                    :selected="query.category === category.value"
                                            >
                                                {{ category.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="subject">
                                            {{ $t('label.subject') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="subject"
                                                name="subject"
                                                id="subject"
                                                v-model="query.subject"
                                        />
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                            <kt-form-row v-else>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="id">
                                            {{ $t('label.id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="id"
                                                dir="ltr"
                                                name="id"
                                                id="id"
                                                v-model="query.id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="created_at">
                                            {{ $t('label.created_at') }}
                                        </kt-form-label>
                                        <button @click="clearCreatedAt"
                                                class=" btn btn-label-danger trash-btn"
                                                type="button"
                                        >
                                            <i class="la la-trash-o"></i>
                                        </button>
                                        <datePicker
                                                color="#00c1a4"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                v-model="query.created_at" type="date" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="category">
                                            {{ $t('label.category') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="category" class="form-control" name="category" v-model="query.category">
                                            <option :value="null"></option>
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(category, index) in categories"
                                                    v-bind:value="category.value"
                                                    :selected="query.category === category.value"
                                            >
                                                {{ category.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                            <kt-form-row v-if="$can('read', 'ticket')">
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.full_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="full_name"
                                                dir="ltr"
                                                name="full_name"
                                                id="full_name"
                                                v-model="query.full_name"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="email">
                                            {{ $t('label.email') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="email"
                                                dir="ltr"
                                                name="email"
                                                id="email"
                                                v-model="query.email"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                            <kt-form-row v-else>
                                <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                        <kt-form-label for="subject">
                                            {{ $t('label.subject') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="subject"
                                                name="subject"
                                                id="subject"
                                                v-model="query.subject"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>

                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import $ from 'jquery'
import { ticketStatus, statusStr } from '@/constants/ticketStatus'
import { mapGetters } from 'vuex';

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data: function() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: statusStr.SEEN_BY_USER,
                    value: ticketStatus.SEEN_BY_USER
                },
                {
                    name: statusStr.CREATED_BY_ADMIN,
                    value: ticketStatus.CREATED_BY_ADMIN
                },
                {
                    name: statusStr.CLOSED_BY_ADMIN,
                    value: ticketStatus.CLOSED_BY_ADMIN
                },
                {
                    name: statusStr.SEEN_BY_ADMIN,
                    value: ticketStatus.SEEN_BY_ADMIN
                },
                {
                    name: statusStr.REPLIED_BY_ADMIN,
                    value: ticketStatus.REPLIED_BY_ADMIN
                },
                {
                    name: statusStr.REPLIED_BY_USER,
                    value: ticketStatus.REPLIED_BY_USER
                }
            ],
            categories: [],
            query: {},
        }
    },
    computed: {
        ...mapGetters('ticket', [
            'status'
        ])
    },
    watch: {
        status: function() {
            this.categories = this.$store.state.ticket.categories
        }
    },
    methods: {
        clearCreatedAt() {
            if(this.query.created_at) {
                this.query.created_at = null
            }
        },
    }
}
</script>

<style>

</style>